import { useMemo } from "react"
import { FieldType, FieldValue, FormField, option } from "../../../../../features/ui"
import { TableName } from "../../../../../tables"
import { useVehicleLoaders } from "../../../loaders/vehicleLoaders"
import { useVehicleHooks } from "../../../hooks/vehicleHooks"

type Props = {
    defaultValue?: string
    value?: string
    disabled?: boolean
    onChange?: (value?: FieldValue) => void
}

export const VehicleField = (props: Props): FormField => {
    const { defaultValue, value, disabled, onChange } = props

    const { describeVehicle } = useVehicleHooks()

    const vehicleLoaders = useVehicleLoaders()

    const options = useMemo(() => {
        const allVehicles = vehicleLoaders().findAllVehicles(true)
        return allVehicles.map(vehicle => option(vehicle.id, describeVehicle(vehicle)))
    }, [])

    return {
        name: 'vehicleId',
        type: FieldType.TABLE,
        table: TableName.VEHICLES,
        label: 'Vehículo',
        defaultValue,
        value,
        options,
        disabled,
        onChange
    }
}
